export const REFETCH_DATA = 'REFETCH_DATA'

export const NUMBER_PRECISION = 2
export const ANIMATION_DELAY = 300
export type REVENUE_TYPES = 'country' | 'stores' | 'general'

export const METRICS_TYPES = {
  SURFACE: 'SURFACE',
}

export enum STORES_TYPE {
  'NEW' = 'new',
  'ALL' = 'all',
  'WEBSITE' = 'website',
  'STATIONARY' = 'stationary',
  'OPENED_1Y' = 'OPENED_1Y',
  'CHANGED_1Y' = 'CHANGED_1Y',
  'CHANGED_30D' = 'CHANGED_30D',
  'FLOOR_SPACE_DECREASED1Y_ONLY' = 'floorSpaceDecreased1yOnly',
  'FLOOR_SPACE_DECREASED30D_ONLY' = 'floorSpaceDecreased30dOnly',
  'FLOOR_SPACE_INCREASED1Y_ONLY' = 'floorSpaceIncreased1yOnly',
  'FLOOR_SPACE_INCREASED30D_ONLY' = 'floorSpaceIncreased30dOnly',
}

export const ROLES = {
  ADMIN: 'Admin',
  BOARD: 'Board',
  SUPERVISORY_BOARD: 'SupervisoryBoard',
  DIRECTOR: 'Director',
}

export const PATHS = {
  ERROR: '/error',
  NO_ACCESS: '/no-access',
  RANKINGS: '/rankings',
  ROOT: '/',
}

export enum SORT_ORDER {
  'ASC' = 'asc',
  'DESC' = 'desc',
}

export enum METHODS {
  'GET' = 'get',
  'PATCH' = 'patch',
  'POST' = 'post',
}

export const CLUSTER = {
  E: 'E',
}

export const ECOM_CLUSTERS = [CLUSTER.E]
